import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { getPurchases, getStore } from '../api'
import Gift from '../views/Gift'
import Loading from '../views/common/Loading'

const useGift = () => {
  const [gift, setGift] = useState()
  const [loading, setLoading] = useState()
  const { id, paid } = useParams()

  useEffect(() => {
    const [giftId, giftDate] = id.split('+')

    const getUnPaidGift = async () => {
      const store = await getStore()
      const categoryItem = store && store.categories &&
        store.categories.find(category =>
          category.items &&
          category.items.find(item =>
            item.id === giftId
          )
        )
      const giftItem = categoryItem && categoryItem.items.find(item =>
        item.id === giftId
      )
      return giftItem
    }

    const getPaidGift = async () => {
      const purchases = await getPurchases()
      const giftItemData = purchases && purchases.purchaseHistory &&
        purchases.purchaseHistory.find(item =>
          item.item && item.item.id === giftId && item.purchaseDate && (!giftDate || item.purchaseDate.toString() === giftDate)
        )
      const giftItem = giftItemData && {
        ...giftItemData.item,
        purchaseDate: giftItemData.purchaseDate,
        expirationDate: giftItemData.expirationDate
      }
      return giftItem
    }

    const getGift = async () => {
      setLoading(true)

      const isPaid = paid === 'paid'
      const giftItem = isPaid ? await getPaidGift() : await getUnPaidGift()

      giftItem && setGift({ ...giftItem, isPaid })
      setLoading(false)
    }

    getGift()
  }, [id, paid])

  return [gift, loading]
}

export default ({ loyalty: { status: { point } } }) => {
  const [gift, loading] = useGift()

  const history = useHistory()
  loading === false && !gift && history.push('/')

  return (
    loading ?
      <Loading />
      :
      gift && gift.id ?
        <Gift {...gift} score={point} />
        :
        <div />
  )
}
